enum PurchaseState {
  USED = 'Used',
  NEW = 'New',
  PRE_OWNED = 'Pre-Owned',
}

export default PurchaseState;
